import React from 'react'
import {COLORS, Icon, THEME_COLORS} from 'ac_ui'
import {acDigitOne, acDigitThree, acDigitTwo} from 'ac-icon'
import {isMacintosh} from '../utils'
import {useSelector} from 'react-redux'
import {IReduxState} from '../../../redux/types/IReduxState'
import {UserDto} from 'learndb-share'
import classNames from 'classnames'

interface IEditorSettingProps {
  id: string
  onSetWindowStyle?: (newStyle: number) => void
}

const EditorSetting: React.FC<IEditorSettingProps> = ({onSetWindowStyle}): React.ReactElement => {
  const user = useSelector<IReduxState, UserDto | undefined>((state) => state.auth?.user)
  const userAnonymous = useSelector<IReduxState, UserDto | undefined>((state) => state.auth?.userAnonymous)

  let windowStyle = 0
  if (user && user.setting) {
    windowStyle = user.setting.windowStyle
  } else if (userAnonymous && userAnonymous.setting) {
    windowStyle = userAnonymous.setting.windowStyle
  }

  return (
    <div className={'custom-scroll h-100 pt-x6 pb-0 pr-x3 pl-x6 mr-x1'}>
      <div className={'window-style-list'}>
        <div
          onMouseDown={(e) => e.preventDefault()}
          onClick={(e) => {
            e.preventDefault()
            onSetWindowStyle(0)
          }}
          className={classNames('window-style-list-item', {
            active: windowStyle === 0,
          })}>
          <div className={'d-flex flex-row'}>
            <div className={'wsi-number'}>
              <Icon
                path={acDigitOne}
                color={windowStyle === 0 ? COLORS.white : THEME_COLORS.primary}
                size={'16px'}
                title={undefined}
              />
            </div>
            <div className={'d-flex flex-column'}>
              <p className={'wsi-name'}>По умолчанию</p>
              <p className={'wsi-description'}>{isMacintosh() ? 'Ctrl + Shift' : 'Ctrl + Shift'} + 1</p>
            </div>
          </div>
          <img
            src={`/img/task/ws1${windowStyle === 0 ? '-active' : ''}.svg`}
            className={'wsi-img'}
            width={'100%'}
            height={'auto'}
            alt={'Пресет'}
          />
        </div>
        <div
          onMouseDown={(e) => e.preventDefault()}
          onClick={(e) => {
            e.preventDefault()
            onSetWindowStyle(1)
          }}
          className={classNames('window-style-list-item', {
            active: windowStyle === 1,
          })}>
          <div className={'d-flex flex-row'}>
            <div className={'wsi-number'}>
              <Icon
                path={acDigitTwo}
                color={windowStyle === 1 ? COLORS.white : THEME_COLORS.primary}
                size={'16px'}
                title={undefined}
              />
            </div>
            <div className={'d-flex flex-column'}>
              <p className={'wsi-name'}>Условия задачи и ER-диаграмма на одном экране</p>
              <p className={'wsi-description'}>{isMacintosh() ? 'Ctrl + Shift' : 'Ctrl + Shift'} + 2</p>
            </div>
          </div>
          <img
            src={`/img/task/ws2${windowStyle === 1 ? '-active' : ''}.svg`}
            className={'wsi-img'}
            width={'100%'}
            height={'auto'}
            alt={'Пресет'}
          />
        </div>
        <div
          onMouseDown={(e) => e.preventDefault()}
          onClick={(e) => {
            e.preventDefault()
            onSetWindowStyle(2)
          }}
          className={classNames('window-style-list-item', {
            active: windowStyle === 2,
          })}>
          <div className={'d-flex flex-row'}>
            <div className={'wsi-number'}>
              <Icon
                path={acDigitThree}
                color={windowStyle === 2 ? COLORS.white : THEME_COLORS.primary}
                size={'16px'}
                title={undefined}
              />
            </div>
            <div className={'d-flex flex-column'}>
              <p className={'wsi-name'}>Расширенный</p>
              <p className={'wsi-description'}>{isMacintosh() ? 'Ctrl + Shift' : 'Ctrl + Shift'} + 3</p>
            </div>
          </div>
          <img
            src={`/img/task/ws3${windowStyle === 2 ? '-active' : ''}.svg`}
            className={'wsi-img'}
            width={'100%'}
            height={'auto'}
            alt={'Пресет'}
          />
        </div>
      </div>
    </div>
  )
}

export {EditorSetting}
